<div class="cart-popup" [ngStyle]="{
    '--cart-bg': settingsData?.bg_tertiary_color,
    '--cart-fg': settingsData?.font_tertiary_color,
    'font-family': settingsData?.font_family}">
    <div class="cart-popup__head">
        <span class="cart-popup__title">Your Cart ({{count}})</span>
        <div class="cart-popup__links">
            <button type="button" class="cart-popup__link" *ngIf="products?.length > 1" (click)="askClearAll()">Clear all</button>
            <button type="button" class="cart-popup__link" (click)="closed.emit()">Close</button>
        </div>
    </div>

    <div class="cart-popup__confirm" *ngIf="confirmAll">
        <p>Remove all {{products.length}} items from your cart?</p>
        <ng-container *ngTemplateOutlet="confirmActions"></ng-container>
    </div>

    <div class="cart-popup__list">
        <div class="cart-item" *ngFor="let product of products">
            <div class="cart-item__row">
                <div class="cart-item__thumb pointer" role="link" tabindex="0" [attr.aria-label]="product?.product_data?.name" (click)="openProduct.emit(product)" (keydown.enter)="openProduct.emit(product)">
                    <img appHideBrokenImg [src]="product.product_data.media_url[0]" [alt]="product.product_data.name" loading="lazy">
                </div>
                <div class="cart-item__info">
                    <div class="cart-item__name pointer" role="link" tabindex="0" (click)="openProduct.emit(product)" (keydown.enter)="openProduct.emit(product)" matTooltipPosition="above" [matTooltip]="product?.product_data?.name">
                        {{ product?.product_data?.name }}</div>
                    <div class="cart-item__desc" *ngIf="product?.product_data?.short_description" matTooltipPosition="above"
                        [matTooltip]="product.product_data.short_description">{{ product.product_data.short_description }}</div>
                    <div class="cart-item__meta" *ngIf="product?.product_data?.brand_name">{{ product.product_data.brand_name }}</div>
                    <div class="cart-item__attrs" *ngIf="product?.product_data?.attributes?.length">
                        <ng-container *ngFor="let attr of product.product_data.attributes">
                            <span class="cart-item__chip" *ngIf="attr?.selected_attr">{{attr.attribute_name}}: {{attr.selected_attr}}</span>
                        </ng-container>
                    </div>
                    <div class="cart-item__price">
                        {{ product.price * (product.quantity || 1) | currency: currencyOf(product) }}
                        <span class="cart-item__qty" *ngIf="product?.quantity > 1">· Qty {{product.quantity}}</span>
                    </div>
                </div>
                <button type="button" class="cart-item__delete" (click)="askRemove(product.id)"
                    matTooltipPosition="above" matTooltip="Remove" aria-label="Remove">
                    <i class="fa fa-trash"></i>
                </button>
            </div>
            <div class="cart-popup__confirm" *ngIf="pendingId === product.id">
                <p>Remove this item from your cart?</p>
                <ng-container *ngTemplateOutlet="confirmActions"></ng-container>
            </div>
        </div>
    </div>

    <div class="cart-popup__subtotal" *ngIf="subtotal">
        <span>Subtotal</span>
        <span>{{ subtotal.amount | currency: subtotal.currency }}</span>
    </div>
    <button class="cart-popup__checkout" mat-flat-button [disabled]="busy" (click)="checkout.emit()">Checkout</button>
</div>

<ng-template #confirmActions>
    <div class="cart-popup__confirm-actions">
        <button type="button" class="cart-btn cart-btn--ghost" [disabled]="busy" (click)="cancel()">Cancel</button>
        <button type="button" class="cart-btn cart-btn--outline" [disabled]="busy" (click)="remove(true)">Move to wishlist</button>
        <button type="button" class="cart-btn cart-btn--solid" [disabled]="busy" (click)="remove(false)">Remove</button>
    </div>
</ng-template>
